module.exports = __webpack_public_path__ + "img/report-timeframes.87582edd.png";